import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Dia } from 'modelos/src';

/**
 * Selector de días de la semana como círculos (L M M J V S D). Emite `Dia[]`
 * con los valores del modelo (sin tildes) y siempre en orden de la semana,
 * no en el orden de los clics.
 */
@Component({
  selector: 'app-dias-semana-selector',
  standalone: true,
  templateUrl: './dias-semana-selector.component.html',
  styleUrls: ['./dias-semana-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DiasSemanaSelectorComponent),
      multi: true,
    },
  ],
})
export class DiasSemanaSelectorComponent implements ControlValueAccessor {
  public readonly dias: { valor: Dia; label: string; nombre: string }[] = [
    { valor: 'Lunes', label: 'L', nombre: 'Lunes' },
    { valor: 'Martes', label: 'M', nombre: 'Martes' },
    { valor: 'Miercoles', label: 'M', nombre: 'Miércoles' },
    { valor: 'Jueves', label: 'J', nombre: 'Jueves' },
    { valor: 'Viernes', label: 'V', nombre: 'Viernes' },
    { valor: 'Sabado', label: 'S', nombre: 'Sábado' },
    { valor: 'Domingo', label: 'D', nombre: 'Domingo' },
  ];

  public seleccionados: Dia[] = [];
  public disabled = false;

  private onChange: (v: Dia[]) => void = () => {};
  private onTouched: () => void = () => {};

  public activo(dia: Dia): boolean {
    return this.seleccionados.includes(dia);
  }

  public toggle(dia: Dia): void {
    if (this.disabled) return;
    const actuales = this.seleccionados;
    this.seleccionados = this.dias
      .map((d) => d.valor)
      .filter((d) =>
        d === dia ? !actuales.includes(d) : actuales.includes(d),
      );
    this.onChange(this.seleccionados);
    this.onTouched();
  }

  public writeValue(value: Dia[] | null): void {
    this.seleccionados = value ?? [];
  }

  public registerOnChange(fn: (v: Dia[]) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
